import { ReactElement } from 'react';

import { useMediaQuery } from '@mui/material';

import OSwipeableDrawer from '../OSwipeableDrawer';
import OModal, { IOModalProps } from '../OModal';

interface IOResponsiveModal {
  children: ReactElement | ReactElement[];
  isOpen: boolean;
  title?: string;
  onClose: () => void;
  modalClasses?: {
    modal?: string;
    container?: string;
    body?: string;
    header?: string;
    closeIcon?: string;
    closeIconWrapper?: string;
    title?: string;
  };
  drawerActions?: {
    onApply?: () => void;
    onCancel?: () => void;
    applyLabel?: string;
    cancelLabel?: string;
  };
  hasBackdrop?: boolean;
  oModalProps?: Partial<IOModalProps>;
}

const OResponsiveModal = ({
  children,
  isOpen,
  title,
  onClose,
  modalClasses,
  drawerActions,
  hasBackdrop = false,
  oModalProps,
}: IOResponsiveModal) => {
  const isMobile = useMediaQuery('(max-width:768px)');

  return isMobile ? (
    <OSwipeableDrawer
      isOpen={isOpen}
      onClose={onClose}
      classes={modalClasses}
      title={title}
      hasBackdrop={hasBackdrop}
      {...drawerActions}
    >
      {children}
    </OSwipeableDrawer>
  ) : (
    <OModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      classes={modalClasses}
      hasBackdrop={hasBackdrop}
      {...oModalProps}
    >
      {children}
    </OModal>
  );
};

export default OResponsiveModal;
